import { PayExAppTypeEnum } from '../../_store/stringConstants';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
    import { map } from 'rxjs/internal/operators/map';
import { MenuItems } from '../../_store/menuItems';
import { StringConstants } from '../../_store/stringConstants';
import { AppConfigService } from './appConfigService';
import { StorageService } from './storage.service';
import { HttpUtilityService } from './utility.service';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<any>;
    private currentSellerSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;
    public currentSeller: Observable<any>;
    private userSessionString = 'currentLoggedInUserUnifiedDashboard';

    constructor(
        private appConfigService: AppConfigService,
        private httpUtilityService: HttpUtilityService,
        private strorageService: StorageService
    ) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(this.getUserDataToSessionStorage()));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserData(): any {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        const req = {
            username: username,
            userName: username,
            password: password
        };
        const loginUrl = `${this.appConfigService.appName}_LOGIN`;
        const url = this.appConfigService.urls[loginUrl] ? this.appConfigService.urls[loginUrl] : this.appConfigService.urls.LOGIN;
        return this.httpUtilityService.httpPost(req, url).pipe(map(data => {
            const respData = data.data || data.response || data;
            const userData: any = {
                loginData: respData,
                userData: respData.user,
                session: respData.session,
                userId: username,
                username: (respData.user && (respData.user.displayName || respData.user.supplierCode)) || 'Test User',
                userRoles: ((respData.user && (respData.user.userRole || respData.user.userRoles)) || 'user').split(','),
                forcePinChange: (respData.user || {}).forcePinChange
            };
            const userRolesMap = userData.userRoles.reduce((userRoles, role) => {
                userRoles[role] = 1;
                return userRoles;
            }, {});
            const appStateNames = {};
            this.appConfigService.menuItems.forEach((menuItem) => {
                const stateAllowed = menuItem.roles.find(role => userRolesMap[role]);
                if (stateAllowed) {
                    appStateNames[menuItem.stateKey] = 1;
                }
                if (menuItem.children && menuItem.children.length) {
                    menuItem.children.forEach(childMenuItem => {
                        const childStateAllowed = childMenuItem.roles.find(role => userRolesMap[role]);
                        if (childStateAllowed) {
                            appStateNames[childMenuItem.stateKey] = 1;
                        }
                    });
                }
            });
            userData.appStateNames = appStateNames;
            this.setUserDataToSessionStorage(userData);
            this.currentUserSubject.next(userData);
            return userData;
        }));
    }

    setCurrentUser(userData: any) {
        console.log("setting user data");
        console.log(userData,'userData');
        this.currentUserSubject.next(userData);
    }

    changePassword(password: string, newpassword: string) {
        const userData = this.currentUserData;
        const req = {
            username: userData.userId,
            password: password,
            newPassword: newpassword,
            session: userData.session,
            type: PayExAppTypeEnum.PAYEX_AP
        };
        return this.httpUtilityService.httpPost(req, this.appConfigService.urls.CHANGEPASSWORD).pipe(map(data => {
            const respData = data.data || data.response || data;
            if (respData.status === 'success') {
                this.resetForcePinChangeFlag();
            }
            return data;
        }));
    }

    logout() {
        sessionStorage.clear();

        this.strorageService.remove(Object.keys(StringConstants.STORAGE_KEYS).map(key => StringConstants.STORAGE_KEYS[key]));
        this.currentUserSubject.next(null);
    }

    getMenuItemsForUser() {
        const checkMenuAccessible = (stateKey) => {
            return typeof userAppStates[stateKey] !== 'undefined';
        };
        const currentUser = this.currentUserData;
        const userAppStates = currentUser.appStateNames || [];
        const appMenuItems = this.appConfigService.menuItems;
        const allowedStates = {};
        const userMenuItems = appMenuItems.filter(menuItem => {
            let isMenuAccessible = false;
            if (!menuItem.children) {
                menuItem.children = [];
            }
            if (!menuItem.children.length) {
                isMenuAccessible = checkMenuAccessible(menuItem.stateKey);
            } else {
                // check if any of the children is accessible
                const subMenuItems = menuItem.children.filter((childMenuItem: any) => {
                    const isAccessible = checkMenuAccessible(childMenuItem.stateKey);
                    childMenuItem.isAccessible = isAccessible;
                    if (childMenuItem.isAccessible) {
                        allowedStates[childMenuItem.stateKey] = 1;
                    }
                    return isAccessible;
                });
                isMenuAccessible = subMenuItems.length > 0;
            }
            if (isMenuAccessible) {
                allowedStates[menuItem.stateKey] = 1;
            }
            return isMenuAccessible;
        });
        this.currentUserData.allowedStates = allowedStates;
        this.setUserDataToSessionStorage(this.currentUserData);
        return userMenuItems;
    }

    resetForcePinChangeFlag() {
        this.currentUserData.forcePinChange = undefined;
        this.setUserDataToSessionStorage(this.currentUserData);
        this.currentUserSubject.next(this.currentUserData);
    }

    private setUserDataToSessionStorage(userData) {
        this.strorageService.add(StringConstants.USER_sessionStr, JSON.stringify(userData));
    }

    private getUserDataToSessionStorage() {
        return this.strorageService.get(StringConstants.USER_sessionStr);
    }

    private clearUserDataFromSession() {
        this.strorageService.remove(StringConstants.USER_sessionStr);
    }

    userInRoles(rolesToCheck) {
        const userRolesMap = (this.currentUserData.userRoles || []).reduce((userRoles, role) => {
            userRoles[role] = 1;
            return userRoles;
        }, {});
        return rolesToCheck.reduce((retVal, role) => {
            return retVal || (userRolesMap[role] ? true : false);
        }, false);
    }
}

